import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import indigo from '@material-ui/core/colors/indigo';

import {
  Estimate,
  Maintenance,
  Quote
} from '../Tasks';

import {
  startAddProjectTask,
  startEditProjectTask
} from '../../../../store/actions/projectTasks';

const styles = theme => ({
  avatar: {
    marginRight: theme.spacing.unit*2,
  },
  rootContent: {
    backgroundColor: indigo[50],
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
});

class TaskDialog extends Component {
  constructor(props) {
    super(props);
    const { taskData } = props;

    this.state = {
      task: {...taskData},
    };
  }

  handleChange (propertyName, value) {
    this.setState(function(prevState, props){
       return {
         task: {
           ...prevState.task,
           [propertyName]: value,
         }
       }
    });
  }

  render() {
    const {
      classes,
      project,
      show,
      type,
      handleClose,
      startAddProjectTask,
      startEditProjectTask,
    } = this.props;
    const { task } = this.state;

    return(
      <div>
        <Dialog
          maxWidth="md"
          open={show}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle>
            <div className={classes.row}>
              <Avatar aria-label="Receipt" className={classes.avatar}>
                {task.type.substring(0,1).toUpperCase()}
              </Avatar>
              <div>
                <Typography variant="subheading">
                  {type === "edit" ? "Edit Task" : "Add Task"}
                </Typography>
                <Typography variant="caption">
                  {task.type}
                </Typography>
              </div>
            </div>
          </DialogTitle>
          <DialogContent classes={{root: classes.rootContent}}>
            {task.type === "maintenance" &&
              <Maintenance
                task={task}
                handleChange={this.handleChange.bind(this)}
              />
            }
            {(task.type === "estimate" || task.type === "simple") &&
              <Estimate task={task} handleChange={this.handleChange.bind(this)} />
            }
            {task.type === "quote" &&
              <Quote task={task} handleChange={this.handleChange.bind(this)} />
            }
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button
              disabled={task.type === undefined ? true : false}
              onClick={() => {
                if (type === "add") {
                  startAddProjectTask({projectId: project.id, ...task})
                    .then(() => handleClose());

                } else {
                  const { id, ...updates } = task;
                  startEditProjectTask(id, updates)
                    .then(() => handleClose());
                }
              }}
              color="primary">
              {type === "add" ? "Add" : "Done"}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  startEditProjectTask: (id, updates) => dispatch(startEditProjectTask(id, updates)),
  startAddProjectTask: (projectTask) => dispatch(startAddProjectTask(projectTask)),
});

export default compose(
  withStyles(styles),
  connect(null, mapDispatchToProps)
)(TaskDialog);



// WEBPACK FOOTER //
// ./src/components/admin/Jobs/Dialog/TaskDialog.jsx